import axios from "axios"

const URL = process.env.REACT_APP_MASTER_URL

export async function getSharepointList() {
  console.log("inside getSharepointList")
  const url = `${URL}/enquiry/sharepointlist`;
  console.log("inside getSharepointList", url)

  let response = await axios.get(url);
  console.log("inside getSharepointList", response.data)

  return response.data;
}

export async function getMasterData() {
  console.log("inside getMasterData")
  const url = `${URL}/enquiry/sharepointlist/getmasterdata`;
  console.log("inside getMasterData", url)

  let response = await axios.get(url);
  console.log("inside getMasterData", response.data)

  return response.data;
}

export async function getDealerMasterData() {
  console.log("inside getDealerMasterData")
  const url = `${URL}/enquiry/sharepointlist/dealerData`;
  console.log("inside getDealerMasterData", url)

  let response = await axios.get(url);
  console.log("inside inside getDealerMasterData", response.data)

  return response.data;
}


export async function addEnquiryMaster(data) {

  let url = `${URL}/enquiry/sharepointlist/`;
  let response = await axios.post(url, data);
  console.log("EDIT ENQUIRY URL: ", response, response.data)
  return response.data;
}

export async function editEnquiryMaster(data) {
  let url = `${URL}/enquiry/sharepointlist/update`;
  let response = await axios.post(url, data);
  return response.data;
}

export async function editLostOrderData(data) {
  let url = `${URL}/enquiry/sharepointlist/update/lostorder`;
  let response = await axios.post(url, data);
  console.log("response in edit lost:", response.data)
  return response.data;
}